import {DataTable, DataTableProps} from "../DataTable/DataTable";
import {RouteEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {DefaultText} from "../../text/DefaultText/DefaultText";
import {Anchor} from "@mantine/core";
import {Link} from "react-router-dom";
import {useDataTableSorter} from "../DataTable/useDataTableSorter";
import {usePagination} from "../DataTable/usePagination";
import {useRouteDataTableFilter} from "./useRouteDataTableFilter";
import {getColumnFilterProps} from "../DataTable/useDataTableFilter";
import {sortBy} from "lodash";
import {EntityDataTableProps} from "../EntityDataTable/EntityDataTable";
import {EntityAnchor} from "../../anchor/EntityAnchor/EntityAnchor";
import {useMemo} from "react";

const EMPTY_ARRAY: RouteEntity[] = []

export type RouteDataTableProps = EntityDataTableProps<RouteEntity>

export const RouteDataTable = (props: RouteDataTableProps) => {
  const {
    records: routes = EMPTY_ARRAY,
    recordsPerPageOptions,
    ...rest
  } = props

  const {t} = useTranslation(["common"]);

  const {filteredRecords, filterConfig} = useRouteDataTableFilter({
    records: routes
  })

  const sortConfig = useMemo(() => {
    return {
      "name": {
        sortAll: (records, columnAccessor) => {
          return sortBy(records, [function (record) {
            return record.name?.toLowerCase()
          }])
        }
      },
    }
  }, [])

  const {
    sortedRecords,
    sortStatus,
    onSortStatusChange,
  } = useDataTableSorter({
    records: filteredRecords,
    sortStatus: {columnAccessor: 'name', direction: 'asc'},
    sortConfig: sortConfig,
  })

  const pagination = usePagination({
    data: sortedRecords,
    recordsPerPageOptions: recordsPerPageOptions,
  });

  return (
    <DataTable
      {...rest}
      {...(pagination ?? {})}
      sortStatus={sortStatus}
      onSortStatusChange={onSortStatusChange}
      columns={[
        {
          ...getColumnFilterProps(filterConfig, "name"),
          title: t("table.entity.route.column.name", "Name"),
          accessor: "name",
          width: 100,
          sortable: true,
          render: (record) => (
            <EntityAnchor value={record} />
          ),
        },
        {
          ...getColumnFilterProps(filterConfig, "group"),
          title: t("table.entity.route.column.group", "Group"),
          accessor: "routeGroupName",
          width: 100,
          sortable: true,
          render: ({routeGroupId, routeGroupName}) => (
            routeGroupId ? <DefaultText value={routeGroupName}/> : undefined
          )
        },
        {
          ...getColumnFilterProps(filterConfig, "company"),
          title: t("table.entity.route.column.company", "Company"),
          accessor: "companyName",
          width: 100,
          sortable: true,
          render: ({companyId, companyName}) => (
            companyId ? <DefaultText value={companyName}/> : undefined
          )
        }
      ]}
    />
  );
};
